import { create } from "zustand";

const useCartStore = create((set, get) => ({
  items: JSON.parse(localStorage.getItem("cart")) || [],

  addToCart: (product, quantity = 1) => {
    const items = get().items;

    // On considère un article comme "le même" uniquement si
    // id ET description sont identiques
    const existing = items.find(
      (item) =>
        item.id === product.id &&
        (item.description || "") === (product.description || "")
    );

    let newItems;

    if (existing) {
      // Même produit + même personnalisation → on incrémente
      newItems = items.map((item) =>
        item.id === product.id &&
        (item.description || "") === (product.description || "")
          ? { ...item, quantity: item.quantity + quantity }
          : item
      );
    } else {
      // Nouveau produit OU même produit avec perso différente → on ajoute
      // On génère un cartItemId unique pour éviter les conflits d'affichage
      newItems = [
        ...items,
        {
          ...product,
          cartItemId: `${product.id}-${Date.now()}`,
          quantity: quantity,
        },
      ];
    }

    localStorage.setItem("cart", JSON.stringify(newItems));
    set({ items: newItems });
  },

  removeFromCart: (cartItemId) => {
    const newItems = get().items.filter(
      (item) => (item.cartItemId || item.id) !== cartItemId
    );
    localStorage.setItem("cart", JSON.stringify(newItems));
    set({ items: newItems });
  },

  updateQuantity: (cartItemId, quantity) => {
    const newItems = get().items.map((item) =>
      (item.cartItemId || item.id) === cartItemId
        ? { ...item, quantity }
        : item
    );
    localStorage.setItem("cart", JSON.stringify(newItems));
    set({ items: newItems });
  },

  clearCart: () => {
    localStorage.removeItem("cart");
    set({ items: [] });
  },

  getTotalPrice: () => {
    const items = get().items;
    return items.reduce((total, item) => {
      const price = parseFloat(item.price);
      return total + price * item.quantity;
    }, 0);
  },
}));

export default useCartStore;